export const MAIN_BUTTON_HEIGHT = 50;
